import { module } from 'modujs';
import { lazyLoadImage, animDepixelate } from '../utils/image';

export default class extends module {
    constructor(m) {
        super(m);

        this.$items = Array.from(this.$('item'))
    }

    init() {
        // HOVER HANDLING
        this.touchStartBind = () => {
            this.isTouch = true;
        }
        this.el.addEventListener('touchstart', this.touchStartBind, { once: true })

        this.enter = (e) => {
            if(this.isTouch) return

            const img = e.target.querySelector('img')

            if(img) {
                if(!img.classList.contains('-loaded')) {
                    lazyLoadImage(img, null, () => {
                        animDepixelate(img)
                    })
                } else {
                    animDepixelate(img)
                }
            }
        }

        for(let item of this.$items) {
            item.addEventListener('mouseenter', this.enter)
            item.addEventListener('focusin', this.enter)
        }
    }

    destroy() {
        for(let item of this.$items) {
            item.removeEventListener('mouseenter', this.enter)
            item.removeEventListener('focusin', this.enter)
        }
    }
}
